// extracted by mini-css-extract-plugin
export default {"banner":"styles_banner__unSS7","checkIcon":"styles_checkIcon__zT6cz"};